export class SubscriptionInfo{
    public name?: string;
    public id?: string;
}